import "./styles/Projects.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Project from "../Components/Project";
import BJ1 from "../Components/img/BJ1.png";
import fantasy1 from "../Components/img/Fantasy1.jpg";

const Projects = () => {
  const Fantasytxt = `Fantasy Football Formula is a full‑stack web application that scrapes player rankings 
  from various sources, stores them in a database, and generates consensus averages for users 
  to build personalized fantasy tiers. It teaches tier‑building strategy, lets users customize their own 
  tier layouts, and supports exporting both rankings and tiers with matching color schemes to PDF for draft 
  preparation. The platform includes full authentication with login, registration, and password reset, and 
  uses a React frontend that communicates with a FastAPI backend running on a separate server for data 
  processing and database interaction. It can be found at www.fantasyfootballformula.com.`;

  const BJtxt = `Developed an interactive blackjack simulator that recreates a casino‑style gameplay
   experience using React.js. Implemented full blackjack rules including hit, stand, double, and split 
   actions, along with dealer logic and multi‑hand simulation. Integrated the Deck of Cards API to generate 
   real card data and built a balance‑tracking system that allows users to set a starting bankroll and 
   place bets each round. Simulated a full blackjack table with the dealer and two additional players, 
   enabling realistic game flow and state transitions.`;

  const Websitetxt = `Developed a fully responsive personal portfolio website featuring a dynamic 
  About Me section, an interactive skills overview, and a projects showcase that includes a playable 
  blackjack demo built with React. Implemented a contact form powered by EmailJS to allow visitors 
  to send messages directly to my inbox. Designed the site with a clean layout, reusable components, 
  and smooth navigation to highlight professional experience and technical strengths.`;

  function forwardProject() {
    if (document.getElementById("website").style.display !== "none") {
      document.getElementById("website").style.display = "none";
      document.getElementById("Fantasy").style.display = "flex";
    } else if (document.getElementById("Fantasy").style.display !== "none") {
      document.getElementById("Fantasy").style.display = "none";
      document.getElementById("BJ").style.display = "flex";
    } else {
      document.getElementById("BJ").style.display = "none";
      document.getElementById("website").style.display = "flex";
    }
  }

  function backwardProject() {
    if (document.getElementById("Fantasy").style.display !== "none") {
      document.getElementById("Fantasy").style.display = "none";
      document.getElementById("website").style.display = "flex";
    } else if (document.getElementById("BJ").style.display !== "none") {
      document.getElementById("BJ").style.display = "none";
      document.getElementById("Fantasy").style.display = "flex";
    } else {
      document.getElementById("website").style.display = "none";
      document.getElementById("BJ").style.display = "flex";
    }
  }

  return (
    <section className="projects-page page" id="Projects">
      <h2>Recent Projects</h2>
      <div className="project container row">
        <button className="left column big" onClick={backwardProject}>
          <FaChevronLeft className="arrowBig" />
        </button>
        <Project
          display={"flex"}
          id={"Fantasy"}
          CurrentIMG={fantasy1}
          text={Fantasytxt}
          name={"Fantasy Football Formula"}
        />
        <Project
          display={"none"}
          id={"BJ"}
          CurrentIMG={BJ1}
          text={BJtxt}
          name={"Card Game Simulator"}
        />
        <Project
          display={"none"}
          id={"website"}
          CurrentIMG={false}
          text={Websitetxt}
          name={"Online Portfolio"}
        />
        <button className="right column big" onClick={forwardProject}>
          <FaChevronRight className="arrowBig" />
        </button>
      </div>
    </section>
  );
};

export default Projects;
